import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import ContentLoaderPlaceholder from '@welldev-group/rcl-content-loader-placeholder';
import { StringParam, withDefault, useQueryParams } from 'use-query-params';
import withQueryParamsProvider from '../../../shared/components/withQueryParamsProvider';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';
import ChannelTable from './ChannelTable';
import EmptyTableContent from '../../../shared/components/EmptyTableContent';

const Channels = props => {
  const [workspaceCredentials, setWorkspaceCredentials] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [query, setQuery] = useQueryParams({
    tab: withDefault(StringParam, ''),
  });
  const [isLoading, setIsLoading] = useState(true);

  const { tab } = query;

  const fetchCredentials = async id => {
    const { data } = await httpClient.get(
      routes.affiliates.credentials({
        id,
      }),
    );
    setWorkspaceCredentials(data.workspaceCredentials);
    setSupplierOptions(data.supplierOptions);
    props.fetchAffiliate();
    setIsLoading(false);
  };

  useEffect(() => {
    fetchCredentials(props.affiliateId);
  }, []);

  useEffect(() => {
    if (props.fromAffiliate360) {
      setQuery({ tab: 'channel' }, 'replaceIn');
    }
  }, [tab]);

  const workspaceOptions = workspaceCredentials?.map(workspaceInfo => ({
    value: workspaceInfo.workspaceId,
    label: workspaceInfo.workspaceIdentifier,
  }));

  return (
    <>
      {isLoading ? (
        <ContentLoaderPlaceholder numberOfLines={12} />
      ) : (
        <>
          {workspaceCredentials?.length > 0 ? (
            <Card version="v2" size="full">
              <ChannelTable
                fetchCredentials={fetchCredentials}
                workspaceCredentials={workspaceCredentials}
                workspaceOptions={workspaceOptions}
                supplierOptions={supplierOptions}
                affiliateId={props.affiliateId}
                isLoading={isLoading}
                actionDisabled={props.rowLevelActionDisabled}
              />
            </Card>
          ) : (
            <EmptyTableContent />
          )}
        </>
      )}
    </>
  );
};

Channels.defaultProps = {
  fetchAffiliate: () => {},
  fromAffiliate360: false,
  rowLevelActionDisabled: false,
};

Channels.propTypes = {
  affiliateId: PropTypes.number.isRequired,
  fetchAffiliate: PropTypes.func,
  fromAffiliate360: PropTypes.bool,
  rowLevelActionDisabled: PropTypes.bool,
};

export default withQueryParamsProvider(Channels);
